import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { getForumTopicPosts } from '../../../../service/forumTopicPost';

import PostItem from '../PostItem/PostItem';

interface PropsPostsList {
  forumTopicId: number;
  forumId: number;
  clubId: number;
}

export const PostsList = ({ forumTopicId, forumId, clubId }: PropsPostsList) => {

  const {data: forumTopicPosts, refetch} = useQuery(
    ['club', 'forumTopicPosts', forumTopicId],
    () => getForumTopicPosts(forumTopicId, forumId, clubId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  return(
    <div>
      <div>
        {forumTopicPosts?.map(post => 
          <PostItem forumTopicPost={post} />
        )}
      </div>
      
    </div>
  );
}


